import { DataProviderArgs } from "../../DataStore/DataProvider";
import { IMedia, IPlaceMediaItem, IPlaceReport } from "../../models/Models";
import { IPlace } from "../../models/Models";
import { PlaceMediaTable } from "./PlaceMediaTable";
import { PlaceReportTable } from "./PlaceReportTable";
import { GraphQLTable } from "./GraphQLTable";
import { IPlaceTable } from "../IPlaceTable";
import { awsPlaceToSimplePlace, simplePlaceToAwsPlace } from "../IPlaceTable";
import { Place } from "../../../models";

export class PlaceTable extends GraphQLTable<IPlace> implements IPlaceTable {
    constructor(
        args: DataProviderArgs,
        private readonly _placeMediaItems: PlaceMediaTable,
        private readonly _placeReports: PlaceReportTable
    ) {
        super(
            args,
            [],
            { get: "getPlace", list: "listPlaces", create: "createPlace" },
            (obj: Place) => awsPlaceToSimplePlace(obj),
            (obj: IPlace) => simplePlaceToAwsPlace(obj)
        );
    }

    public async getReports(placeId: string): Promise<IPlaceReport[]> {
        return (await this._placeReports.allByPlaceId(placeId)) ?? [];
    }

    public async getMediaItems(placeId: string): Promise<IPlaceMediaItem[]> {
        return (await this._placeMediaItems.allByPlaceId(placeId)) ?? [];
    }

    public async createReport(_placeId: string, _report: IPlaceReport): Promise<IPlaceReport> {
        throw new Error("Method not implemented.");
    }
    public async deleteReport(_id: string): Promise<void> {
        throw new Error("Method not implemented.");
    }
    public async updateReport(_item: IPlaceReport): Promise<IPlaceReport | undefined> {
        throw new Error("Method not implemented.");
    }
    public async createMediaItem(
        _placeId: string,
        _media: IMedia,
        _groupAccess: string[]
    ): Promise<IPlaceMediaItem> {
        throw new Error("Method not implemented.");
    }
    public async deleteMediaItem(_id: string): Promise<void> {
        throw new Error("Method not implemented.");
    }
    public async updateMediaItem(_item: IPlaceMediaItem): Promise<IPlaceMediaItem | undefined> {
        throw new Error("Method not implemented.");
    }
}
